import PlaceRequests from '../../server/places';
import { addLoading, removeLoading } from './loading';

export const setPlace = place => ({
  type: 'GET_PLACE',
  place,
});

export const setPlaces = places => ({
  type: 'GET_PLACES',
  places,
});

const createPlace = place => async (dispatch) => {
  dispatch(addLoading());
  try {
    await PlaceRequests.createPlace(place);
  } finally {
    dispatch(removeLoading());
  }
};

const updatePlace = place => async (dispatch) => {
  dispatch(addLoading());
  try {
    await PlaceRequests.updatePlace(place);
  } finally {
    dispatch(removeLoading());
  }
};

const getPlace = id => async (dispatch) => {
  dispatch(addLoading());
  try {
    const place = await PlaceRequests.getPlace(id);
    dispatch(setPlace(place));
  } finally {
    dispatch(removeLoading());
  }
};

const getPlaces = (limit, skip, search, force = false, order = '', field = '') => async (dispatch) => {
  if (!search || force) dispatch(addLoading());
  try {
    const places = await PlaceRequests.getPlaces(limit, skip, search, order, field);
    dispatch(setPlaces(places));
  } finally {
    if (!search || force) dispatch(removeLoading());
  }
};

export const getPlacesSelect = (search, force = false) => async (dispatch) => {
  if (!search || force) dispatch(addLoading());
  try {
    const places = await PlaceRequests.getPlaces(1000, 0, search, 'ASC', 'id');
    dispatch(setPlaces(places));
  } finally {
    if (!search || force) dispatch(removeLoading());
  }
};

const deletePlace = id => async (dispatch) => {
  dispatch(addLoading());
  try {
    await PlaceRequests.deletePlace(id);
  } finally {
    dispatch(removeLoading());
  }
};

export default {
  createPlace,
  getPlace,
  getPlaces,
  updatePlace,
  deletePlace,
  getPlacesSelect,
};
